import BlockPadding from '@/components/block-padding';
import { PAGE_SIZE } from '@/lib/datocms/constants';
import { KebabCaseTracker } from '@/lib/utils/kebab-case-tracker';
import { Button } from '@bumble/ui-kit';
import { useRouter } from 'next/router';

import styles from './filter.module.scss';
import Icon from './icon';

interface Props {
  tags: string[];
  setter: (value: any) => void;
}

export default function Filter({ tags = [], setter }: Props) {
  const router = useRouter();
  const tag = router.query.tag;

  const tagsTracker = new KebabCaseTracker();
  tagsTracker.addAll(tags);

  async function fetchFilteredStories() {
    const res = await fetch(
      `/api/stories?first=${PAGE_SIZE}&skip=0${
        tag ? `&tag=${tagsTracker.getRawByKebab(tag as string)[0] || ''}` : ''
      }`,
    );
    const json = await res.json();
    setter(json.allStories || []);
  }

  function handleAllClick() {
    router.push('/stories', undefined, { scroll: false });
    fetchFilteredStories();
  }

  // eslint-disable-next-line @typescript-eslint/no-shadow
  function handleTagClick(tag: string) {
    router.push(`/stories?tag=${tagsTracker.getKebab(tag)}`, undefined, {
      scroll: false,
    });
    fetchFilteredStories();
  }

  return (
    <BlockPadding maxWidth="large">
      <div className={styles.filter}>
        <div className={styles.filters}>
          <span className={styles.icon}>
            <Icon />
          </span>
          <span>Filters</span>
        </div>

        <Button
          text="All"
          labelText="All"
          onClick={handleAllClick}
          color="yellow"
          size="small"
          isInline={true}
        />

        {/* eslint-disable-next-line id-length */}
        {tags.sort().map((t) => {
          const selected = tag === tagsTracker.getKebab(t);
          return (
            <Button
              key={t}
              text={t}
              labelText={t}
              onClick={() => handleTagClick(t)}
              designType="secondary"
              size="small"
              isInline={true}
              isActive={selected}
              isDisabled={selected}
            />
          );
        })}
      </div>
    </BlockPadding>
  );
}
